// @flow

export const defaultObjectState = {
	objects: {},
	ids: [],
	adding: false,
	errors: {},
	editing: 0,
};
